import React from "react";
import image from "../Assets/carteLogoipsum.png";

function NousJoindre() {
  return (
    <div className={`wrapSectionPage`}>
      <div className="entetePage fond1">
        <div className="textItem">
          <h1>Nous Joindre</h1>
        </div>
      </div>
      <div className="rowText rowTextTop">
        <div className="gauche carte">
          <img src={image} alt="carte" />
        </div>
        <div className="droite texte texteCentre">
          <h2>Logoipsum</h2>
          <hr />
          128 North Van Buren Circle Oceanside,
          <br />
          Montana 37551
          <br />
          (602) 908-0172
        </div>
      </div>
    </div>
  );
}

export default NousJoindre;
